<template>
  <div id="doctor-list">
    <div class="row topactionform">
      <div class="col-xs-4" style="padding-right: 0">
        <div class="smalltitle">{{ getPageName }} List
          <br/><span><a style="font-size: 14px; color: rgb(190, 197, 0); text-decoration: underline;" href="javascript:void(0)" @click="showTextUser()">Onboarding instruction</a></span>
          <br/><span style="margin-left: 10px;font-size: 14px; color: rgb(190, 197, 0); text-decoration: underline;"><a class="light" href="javascript:void(0)" @click="showTextEPCS()">EPCS Standard Operation Procedure</a>
          </span>
        </div>
      </div>
      <div class="col-xs-8">
        <form class="onelineform flowsearch" @submit.prevent="filterDoctor">
          <button class="submit btn light" style="float: right; width: 10%" type="submit"><i
              class="fa fa-search"></i></button>
          <span class="selectwrap" style="width: 12%; float: right">
            <select v-model="formSearch.eRxStatus" @change="filterDoctor">
              <option value="">e-Rx</option>
              <option value="active">Activated</option>
              <option value="deactive">Deactivated</option>
            </select>
          </span>
          <span class="selectwrap" style="width: 12%; float: right">
            <select v-model="formSearch.ePcsStatus" @change="filterDoctor">
              <option value="">EPCS</option>
              <option value="active">Activated</option>
              <option value="deactive">Deactivated</option>
            </select>
          </span>
          <span class="selectwrap" style="width: 12%; float: right">
            <select v-model="formSearch.emrStatus" @change="filterDoctor">
              <option value="">EMR status</option>
              <option :value="STATUS_ACTIVE">Activated</option>
              <option :value="0">Deactivated</option>
            </select>
          </span>
          <span class="selectwrap" style="width: 12%; float: right">
            <select v-model="formSearch.status" @change="filterDoctor">
              <option value="">Account status</option>
              <option :value="STATUS_ACTIVE">Activated</option>
              <option :value="0">Deactivated</option>
            </select>
          </span>
          <span class="selectwrap" style="width: 16%; float: right">
            <select v-model="formSearch.taxonomyDescription" @change="filterDoctor">
              <option value="">Taxonomy</option>
              <option v-for="taxonomy in taxonomyDescriptions" :value="taxonomy">{{ taxonomy }}</option>
            </select>
          </span>
          <input v-model="formSearch.keySearch" class="keyinput"
                 placeholder="Name or leave blank for search all"
                 style="width: 14%; border-left: 1px solid #e1e1e1; float: right" type="text">
        </form>
      </div>
    </div>
    <div class="blockcont">
      <ul class="itemlisttable  ptemr-list">
        <li class="itemlisthead">
          <div class="item-name">Full Name</div>
          <div class="item-dob">NPI</div>
          <div class="item-dob">DOB</div>
          <div class="item-created-at">Created</div>
          <div class="item-clinic">Clinic</div>
          <div class="item-clinic">Group</div>
          <div class="item-account-status">Account status</div>
          <div class="item-account-status">Email Status</div>
          <div class="item-emr-status">EMR status</div>
          <div class="item-emr-status" style="width: 8% !important;">Medical License</div>
          <div class="item-emr-status" style="width: 5% !important;">Dea</div>
          <div class="item-sure-status">Surescripts status</div>
          <div class="item-proof">ID Proof</div>
<!--          <div class="item-action itemaction"></div>-->
        </li>
        <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt"><i
            class="fas fa-spinner fa-spin"></i></li>
        <li v-if="!isLoading && dataDoctors.length === 0" style="text-align: center; font-size: 16pt">
          No records found
        </li>
        <li v-for="(doctor, index) in dataDoctors" v-if="!isLoading" class="item-doctor">
          <div class="item-name" @click="showDetailUser(doctor)">
            <div :style="'background-image: url('+doctor.avatar+')'" class="avatar-user"></div>
            {{ doctor.fullName }} <span v-if="doctor.role == 'physician'"><i class="fas fa-book"></i></span>
            <div class="item-sub-info" :title="getMainTaxonomyDescription(doctor)">
              {{ getMainTaxonomyDescription(doctor) }}
            </div>
          </div>
          <div class="item-dob">
            {{ doctor.npi }}
            <div class="item-sub-info" :class="{'is-editor': isEditor(doctor)}">
              {{ isEditor(doctor) ? 'Editor' : 'Not editor' }}
            </div>
          </div>
          <div class="item-dob">
            {{ formatAgeFromBirthday(doctor.birthDay) }}
            <span v-if="doctor.gender" title="Sex">{{ doctor.gender }}</span>
            <div style="font-weight: normal !important; font-size: 10px !important;"
                 title="Date of Birth">{{ formatTime(doctor.birthDay) }}
            </div>
          </div>
          <div class="item-created-at">{{ formatTime(doctor.createdAt) }}</div>
          <div :title="doctor.clinic" class="item-clinic">{{ doctor.clinic }}</div>
          <div :title="doctor.group" class="item-clinic">{{ doctor.group }}</div>
          <div class="item-account-status">{{ getStatusText(doctor.status) }}</div>
          <div class="item-account-status">N/A</div>
          <div class="item-emr-status">{{ getStatusText(doctor.emr_status) }}</div>
          <div class="item-emr-status" style="width: 8% !important; min-height: 1px !important;">
            <div v-if="doctor.licenses && doctor.licenses.length"
                 v-for="(license, index) in doctor.licenses"
            >
              <div v-if="license && license.type === 'medical_license'">
                {{ formatTime(license.expiration_date) }}
              </div>
            </div>
            <div v-if="!doctor.licenses || !doctor.licenses.length">N/A</div>
          </div>
          <div class="item-emr-status" style="width: 5% !important; min-height: 1px !important;">
            <div v-if="doctor.licenses && doctor.licenses.length"
                 v-for="(license, index) in doctor.licenses"
            >
              <div v-if="license && license.type === 'dea'">
                {{ formatTime(license.expiration_date) }}
              </div>
            </div>
            <div v-if="!doctor.licenses || !doctor.licenses.length">N/A</div>
          </div>

          <div class="item-sure-status">
            <div :title="getTitleSurescriptDoctor(doctor)" class="item-surescript-status-text"
                 @click.prevent="showSureScript(doctor)">e-Rx:
              {{ getStatusSurescriptDoctor(doctor) }}
            </div>
            <div  v-if="!doctor.requestUpdateControlledSubstance" :title="getTitleEPCS(doctor)" class="item-surescript-status-text"
                 @click.prevent="showSureScript(doctor)">EPCS: {{ getEPCSStatus(doctor) }}
            </div>
            <div v-if="doctor.requestUpdateControlledSubstance" class="item-surescript-status-text"
                 style="color: #bec500"
                 @click="showModalApproveEPCS(doctor)">EPCS - Pending
            </div>
          </div>
          <div class="item-proof">
            <i class="fas fa-fingerprint" @click.prevent="showIdProof(doctor)"></i>

            <img src="/img/authentication_logo.png" style="margin-left: 5px;width: 15px"
                 @click.prevent="showIdProof(doctor, 'Authentication')">
          </div>
          <div class="item-action itemaction">
            <dropdown>
              <a data-toggle="dropdown" href="javascript:void(0)" title="Action">
                <i aria-hidden="true"
                   class="fa fa-cog"></i></a>
              <template slot="dropdown">
                <div><a :href="getLinkProfileAccount(doctor.id)"
                        target="_blank"
                >Profile</a>
                </div>
                <div>
                  <a href="javascript:void(0)"
                     @click.prevent="loginAsEmr(doctor)">Login as EMR</a>
                </div>
                <div>
                  <a href="javascript:void(0)"
                     @click.prevent="changeStatusAccount(doctor)">{{ getStatusAccountAction(doctor) }}</a>
                </div>
                <div>
                  <a href="javascript:void(0)"
                     @click.prevent="changeStatusEmr(doctor)">{{ getStatusEmrAction(doctor) }}</a>
                </div>
                <div>
                  <a href="javascript:void(0)"  @click.prevent="showModalDeactiveEPCS(doctor)">Deactivate EPCS</a>
                </div>
                <div>
                  <a href="javascript:void(0)"
                     @click.prevent="showModalSetNewPassword(doctor)">Set new password</a>
                </div>
                <div>
                  <a href="javascript:void(0)"
                     style="padding-left: 10px !important;" @click.prevent="convertToEditor(doctor)">
                    <span v-if="doctor.role == 'allergist'">Change to Physician Editor</span>
                    <span v-if="doctor.role == 'physician'">Change to Allergist Immunologist</span>
                  </a>
                </div>
<!--                <div v-if="!doctor.create_clinic_id && !doctor.token_create_clinic">-->
<!--                  <a href="javascript:void(0)"-->
<!--                     @click.prevent="showModalCloneToClinic(doctor)">Clone this doctor to clinic</a>-->
<!--                </div>-->
                <div>
                  <a href="javascript:void(0)"
                     @click.prevent="showModalCloneFromOtherDoctor(doctor)">Import Setting from Other Doctor</a>
                </div>
              </template>
            </dropdown>
          </div>
        </li>
      </ul>
    </div>
    <pagination :currentPage="paginate.page" :perPage="paginate.perPage" :total="paginate.total"
                :totalPages="paginate.totalPages" @updatePerPage="updatePerPage"></pagination>
    <detail-doctor
        v-if="detailDoctor.modal"
        :user="detailDoctor.user"
        @updateModal="detailDoctor.modal = $event"
    >
    </detail-doctor>
    <id-proof-modal
        v-if="detailIdProof.modal"
        :user="detailIdProof.user"
        :activeTab="detailIdProof.typeTab"
        @updateModal="detailIdProof.modal = $event"
    >
    </id-proof-modal>
    <sure-script-modal v-if="dataSureScriptModal.modal"
                       :user="dataSureScriptModal.doctor"
                       @updateDataDoctor="updateDataDoctor"
                       @updateModal="dataSureScriptModal.modal = $event"
    >

    </sure-script-modal>
    <set-new-password v-if="dataNewPassword.modal"
                      :user="dataNewPassword.user"
                      @updateModal="dataNewPassword.modal = $event"
    >
    </set-new-password>
    <authentication-modal v-if="dataAuthenticationModal.modal"
                          :user="dataAuthenticationModal.user"
                          @updateModal="dataAuthenticationModal.modal = $event"
    >
    </authentication-modal>
    <text-info-user
        v-if="textUserModal"
        @updateModal="textUserModal = $event"
    >
    </text-info-user>
    <e-c-p-s-info-user v-if="textEPCSModal"
                    @updateModal="textEPCSModal = $event">
    </e-c-p-s-info-user>
    <clone-to-clinic
        v-if="dataCloneClinic.modal"
        :user="dataCloneClinic.user"
        @sendNotification="cloneClinic"
        @updateCreateId="updateCreateId"
        @updateModal="dataCloneClinic.modal = $event"
    >
    </clone-to-clinic>
    <clone-setting-from-doctor
        v-if="dataCloneFromDoctor.modal"
        :toDoctor="dataCloneFromDoctor.toDoctor"
        @updateModal="dataCloneFromDoctor.modal = $event"
    >
    </clone-setting-from-doctor>
    <modal-approval-epcs v-if="dataApproveEpcs.modal"
                         :doctor="dataApproveEpcs.doctor"
                         @finishApproval="loadListDoctor"
                         @updateModal="dataApproveEpcs.modal = $event"
    >

    </modal-approval-epcs>

    <deactive-e-p-c-s-modal :doctor="dataDeactiveECPS.doctor" v-if="dataDeactiveECPS.modal"
                            @updateModal="dataDeactiveECPS.modal = $event">

    </deactive-e-p-c-s-modal>
  </div>
</template>

<script>
import Pagination from '../../global/Pagination.vue'
import httpClient from '../../client'
import CommonMixin from '../../mixins/general/CommonMixin.vue'
import TimeMixin from '../../mixins/general/TimeMixin.vue'
import UserStatusMixin from '../../mixins/user/UserStatusMixin.vue'
import SurescriptDoctorMixin from '../../mixins/user/SurescriptDoctorMixin.vue'
import ModalApprovalEpcs from '@/components/users/part/doctor/ModalApprovalEpcs.vue'

const DetailDoctor = () => import('./part/DetailDoctor')
const IdProofModal = () => import('./part/IdProofModal')
const SureScriptModal = () => import('./part/SureScriptModal')
const SetNewPassword = () => import('./part/SetNewPassword')
const AuthenticationModal = () => import('./part/AuthenticationModal.vue')

const TextInfoUser = () => import('./part/TextInfoUser.vue')
const ECPSInfoUser = () => import('./part/ECPSInfoUser.vue')

const CloneToClinic = () => import('./part/CloneToClinic.vue')
const CloneSettingFromDoctor = () => import('./part/CloneSettingFromDoctor.vue')
const DeactiveEPCSModal = () => import('./part/DeactiveEPCSModal.vue')
export default {
  name: 'Doctor',
  components: {
    ModalApprovalEpcs,
    Pagination,
    DetailDoctor,
    IdProofModal,
    SureScriptModal,
    SetNewPassword,
    AuthenticationModal,
    TextInfoUser,
    CloneToClinic,
    CloneSettingFromDoctor,
    ECPSInfoUser,
    DeactiveEPCSModal
  },
  mixins: [CommonMixin, TimeMixin, UserStatusMixin, SurescriptDoctorMixin],
  data () {
    return {
      typePage: 'LIST_DOCTOR',
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoading: false,
      dataDoctors: [],
      formSearch: {
        keySearch: '',
        emrStatus: '',
        status: '',
        eRxStatus: '',
        ePcsStatus: '',
        taxonomyDescription: ''
      },
      taxonomyDescriptions: [],
      detailDoctor: {
        modal: false,
        user: {}
      },
      detailIdProof: {
        modal: false
      },
      dataSureScriptModal: {
        modal: false,
        doctor: {}
      },
      dataNewPassword: {
        modal: false,
        user: {}
      },
      dataAuthenticationModal: {
        modal: false,
        user: {}
      },
      textUserModal: false,
      textEPCSModal: false,
      dataCloneClinic: {
        modal: false,
        user: {}
      },
      dataCloneFromDoctor: {
        modal: false,
        toDoctor: null,
        fromDoctor: null
      },
      processingStatus: false,
      dataApproveEpcs: {
        modal: false,
        doctor: null
      },
      dataDeactiveECPS: {
        doctor: null,
        modal: false
      }
    }
  },
  computed: {
    getPageName () {
      return 'Physician'
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    this.loadListDoctor()
    this.loadTaxonomyDescriptions()
  },
  beforeDestroy () {
  },
  methods: {
    // editor = Physician Editor, xem convertToEditor : allergist <-> physician
    isEditor (doctor) {
      return doctor.role === 'physician'
    },
    getMainTaxonomyDescription (doctor) {
      return doctor.mainTaxonomy && doctor.mainTaxonomy.description ? doctor.mainTaxonomy.description : 'N/A'
    },
    async loadTaxonomyDescriptions () {
      try {
        let response = await httpClient.get('/users/taxonomy-descriptions')
        if (response.data.s === 200) {
          this.taxonomyDescriptions = response.data.data
        }
      } catch (e) {
        this.taxonomyDescriptions = []
      }
    },
    showModalApproveEPCS (doctor) {
      this.dataApproveEpcs.doctor = doctor
      this.dataApproveEpcs.modal = true
    },
    showAuthenticationModal (doctor) {
      this.dataAuthenticationModal.user = doctor
      this.dataAuthenticationModal.modal = true
    },
    updateDataDoctor () {
      this.loadListDoctor()
    },
    showModalSetNewPassword (doctor) {
      this.dataNewPassword.modal = true
      this.dataNewPassword.user = doctor
    },
    showSureScript (doctor) {
      this.dataSureScriptModal.modal = true
      this.dataSureScriptModal.doctor = doctor
    },
    showIdProof (doctor, typeTab = '') {
      this.detailIdProof.user = doctor
      this.detailIdProof.modal = true
      this.detailIdProof.typeTab = typeTab
    },
    showDetailUser (user) {
      if (this.typePage === 'LIST_DOCTOR') {
        this.detailDoctor.modal = true
        this.detailDoctor.user = user
      }
    },
    showTextEPCS () {
      this.textEPCSModal = true
    },
    showTextUser () {
      this.textUserModal = true
    },
    showModalCloneToClinic (doctor) {
      this.dataCloneClinic.modal = true
      this.dataCloneClinic.user = doctor
    },
    showModalCloneFromOtherDoctor (doctor) {
      this.dataCloneFromDoctor.modal = true
      this.dataCloneFromDoctor.toDoctor = doctor
    },
    filterDoctor () {
      this.paginate.page = 1
      this.loadListDoctor()
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadListDoctor()
    },
    async loadListDoctor () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      let params = {
        page: this.paginate.page,
        perPage: this.paginate.perPage,
        keySearch: this.formSearch.keySearch
      }
      if (this.formSearch.emrStatus !== '') {
        params.emrStatus = this.formSearch.emrStatus
      }
      if (this.formSearch.status !== '') {
        params.status = this.formSearch.status
      }
      if (this.formSearch.eRxStatus !== '') {
        params.eRxStatus = this.formSearch.eRxStatus
      }
      if (this.formSearch.ePcsStatus !== '') {
        params.ePcsStatus = this.formSearch.ePcsStatus
      }
      if (this.formSearch.taxonomyDescription !== '') {
        params.taxonomyDescription = this.formSearch.taxonomyDescription
      }
      let response = await httpClient.get(`/users/list-doctor`, { params: params })
      this.isLoading = false
      try {
        if (response.data.s === 200) {
          this.dataDoctors = response.data.data.users ? response.data.data.users : []
          this.paginate.page = Number(response.data.data.currentPage)
          this.paginate.total = response.data.data.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    },
    async loginAsEmr (doctor) {
      try {
        let response = await httpClient.post(`/users/login-as-emr`, {
          userId: doctor.id
        })
        if (response.data.s === 200) {
          window.open(response.data.data.redirectUrl, '_blank')
          return
        }
        this.alertError(response.data.msg)
      } catch (e) {
        console.log(e.message)
        this.alertError('Server error.Try again later')
      }
    },
    async convertToEditor (doctor) {
      if (doctor.role != 'allergist') {
        return
      }
      try {
        let response = await httpClient.post(`/doctor/convert-to-editor`, {
          doctorId: doctor.id
        })
        if (response.data.s === 200) {
          doctor.role = 'physician'
          return
        }
        this.alertError(response.data.msg)
      } catch (e) {
        console.log(e.message)
        this.alertError('Server error.Try again later')
      }
    },
    updateCreateId (data) {
      this.dataCloneClinic.user.create_clinic_id = data
    },
    async cloneClinic (data) {
      this.dataCloneClinic.user.token_create_clinic = data
    },
    showModalDeactiveEPCS (doctor) {
      this.dataDeactiveECPS.doctor = doctor
      this.dataDeactiveECPS.modal = true
    }
  }
}
</script>
<style>

</style>
<style scoped="">
.avatar-user {
  width: 20px !important;
  padding-bottom: 20px !important;
  display: inline-block !important;
  border-radius: 50% !important;
  vertical-align: middle !important;
  background-size: cover;
  background-position: top center;
  height: 0;
  background-color: #e1e1e1;
  overflow: hidden;
}

.item-name {
  width: 12% !important;
  min-height: 1px;
  cursor: pointer;
}

/* dòng phụ dưới tên (main taxonomy) và dưới NPI (editor) */
.item-sub-info {
  font-weight: normal !important;
  font-size: 10px !important;
  color: #999;
}

.item-sub-info.is-editor {
  color: #7f9c26;
}

.item-dob {
  width: 5% !important;
  min-height: 1px;
}

.item-created-at {
  width: 5% !important;
  text-align: left !important;
}

.item-clinic {
  width: 10% !important;
  text-align: left !important;
}

.item-proof {
  width: 4% !important;
  text-align: center !important;
  cursor: pointer;
}

.item-account-status {
  width: 8% !important;
  text-align: center !important;
}

.item-emr-status {
  width: 8% !important;
  text-align: center !important;
}

.item-sure-status {
  width: 10% !important;
  text-align: left !important;
  min-height: 1px;
  cursor: pointer;
}

.item-action {
  width: 2% !important;
  float: right;
  min-height: 1px;
  text-align: right !important;
}

.onelineform {
  border-left: none !important;
}

.item-surescript-status-text {
  text-align: left;
}
</style>
